/* global I18n */

import React from "react"
import FaIcon from "components/fa_icon"

function LearningLevelKeys() {
  return (
    <div className="key">
      <div className="item">
        <span className="dot icon--light-blue"></span>
        {I18n.t("js.new_embedded_quiz.study_summary.learning")}
      </div>
      <div className="item">
        <span className="dot icon--logo-blue"></span>
        {I18n.t("js.new_embedded_quiz.study_summary.mastering")}
      </div>
      <div className="item">
        <FaIcon name={"fa-star"} className="icon--gold"/>
        {I18n.t("js.new_embedded_quiz.study_summary.mastery")}
      </div>
    </div>
  )
}

export default LearningLevelKeys
